window.gid = CryptoJS.MD5("guest").toString()

window.encRequest = function () {
    let path, data, callback;
    if (arguments.length == 3) {
        path = arguments[0]
        data = arguments[1]
        callback = arguments[2]
    } else if (arguments.length == 2) {
        path = arguments[0]
        callback = arguments[1]
    }
    let t = (new Date()).toString()
    let p = CryptoJS.AES.encrypt(path, window.gid).toString()
    let b = CryptoJS.AES.encrypt(JSON.stringify(data), window.gid).toString()
    let z = CryptoJS.AES.encrypt(t, window.gid).toString()
    let params = { p, b, z }
    $.get('/eapi', params, (reply) => {
        const bytes = CryptoJS.AES.decrypt(reply.toString(), window.gid)
        const result = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
        if (callback) return callback(result)
    })
}

$(document).ready(function () {
    $('.location-menu').on('click', function () {
        var mapValue = $(this).find('input[name="map"]').val();
        var mapDisplay = document.getElementById('map-display');

        // ganti value src pada iframe
        mapDisplay.src = `https://www.google.com/maps/embed?${mapValue}`;

        $('.location-menu').removeClass('active');
        $(this).addClass('active');
    });

    $("#schedule-widget").schedule();
    $("#schedule-page").schedulePage();
})